// Belt progression data for the Icelandic AI karate challenge.
// Positions follow Iceland's real geography on a viewBox of 0 0 1000 600.
//   White  → Reykjanes / SW
//   Yellow → Snæfellsnes peninsula
//   Orange → Westfjords
//   Green  → North coast
//   Blue   → North-east coast
//   Purple → East fjords
//   Black  → Future / locked, sitting off the SE coast.
export const BELTS = [
  {
    id: 1,
    slug: "white",
    name: "White Belt",
    weeks: "Weeks 1–4",
    weekStart: 1,
    weekEnd: 4,
    quote: "Wax on. Wax off.",
    summary:
      "Greetings, alphabet, the first essential words. Gender recognition and definiteness. The basics most learners underestimate.",
    achievements: [
      "Greetings and introductions",
      "The Icelandic alphabet",
      "First essential words",
      "Noun gender recognition",
      "Definiteness (definite vs. indefinite)",
    ],
    levelComplete: null,
    locked: false,
    color: "#FFFFFF",
    ring: "#A1A1AA",
    map: { x: 190, y: 380 },
  },
  {
    id: 2,
    slug: "yellow",
    name: "Yellow Belt",
    weeks: "Weeks 5–9",
    weekStart: 5,
    weekEnd: 9,
    quote: "The foundation hardens.",
    summary:
      "Nominative and accusative cases. Present tense. Daily routine, family, work, ordering coffee without panicking.",
    achievements: [
      "Nominative & accusative cases",
      "Present tense",
      "Daily routine vocabulary",
      "Family and work talk",
      "Ordering coffee without panicking",
    ],
    levelComplete: 1,
    locked: false,
    color: "#FDE047",
    ring: "#EAB308",
    map: { x: 110, y: 280 },
  },
  {
    id: 3,
    slug: "orange",
    name: "Orange Belt",
    weeks: "Weeks 10–13",
    weekStart: 10,
    weekEnd: 13,
    quote: "Know yourself.",
    summary:
      "Learn the gender of adjectives, describe yourself and others, express yourself in simple terms in the past, present and future. Learn to say what you like, dislike, want and have to do.",
    achievements: [
      "Gender of adjectives",
      "Describing yourself and others",
      "Simple past, present and future",
      "Saying what you like and dislike",
      "What you want and have to do",
    ],
    levelComplete: null,
    locked: false,
    color: "#F97316",
    ring: "#C2410C",
    map: { x: 340, y: 100 },
  },
  {
    id: 4,
    slug: "green",
    name: "Green Belt",
    weeks: "Weeks 14–18",
    weekStart: 14,
    weekEnd: 18,
    quote: "Ground yourself in the 'now'.",
    summary:
      "Master all the present tense conjugations, sentence structure and plurals. Be confident navigating the calendar, booking health related appointments. Chat with your co-workers about the weather, where you are and where you are going.",
    achievements: [
      "All present tense conjugations",
      "Sentence structure and plurals",
      "Navigating the calendar",
      "Booking health appointments",
      "Small talk about the weather and where you're going",
    ],
    levelComplete: 2,
    locked: false,
    color: "#21b766",
    ring: "#16803d",
    map: { x: 560, y: 220 },
  },
  {
    id: 5,
    slug: "blue",
    name: "Blue Belt",
    weeks: "Weeks 19–22",
    weekStart: 19,
    weekEnd: 22,
    quote: "Bend time to your advantage.",
    summary:
      "Travel through the weak and strong past. Learn present perfect and talk about all the experiences under your (blue) belt. Understand how to use Icelandic cases.",
    achievements: [
      "Weak and strong past tense",
      "Present perfect",
      "Talking about your experiences",
      "Using Icelandic cases with confidence",
    ],
    levelComplete: null,
    locked: false,
    color: "#3B82F6",
    ring: "#1D4ED8",
    map: { x: 740, y: 250 },
  },
  {
    id: 6,
    slug: "purple",
    name: "Purple Belt",
    weeks: "Weeks 23–26",
    weekStart: 23,
    weekEnd: 26,
    quote: "Choose your path wisely: know exactly what you are moving towards.",
    summary:
      "Í vinnuna or í vinnunni? Become confident with staying put, and going new places. Master prepositions, express a wide range of opinions, make requests and ace a job interview. Purple belt: snatched.",
    achievements: [
      "Í vinnuna vs. í vinnunni (motion vs. location)",
      "Prepositions",
      "Expressing a wide range of opinions",
      "Making requests",
      "Acing a job interview",
    ],
    levelComplete: 3,
    locked: false,
    color: "#A855F7",
    ring: "#7E22CE",
    map: { x: 860, y: 350 },
  },
  {
    id: 7,
    slug: "black",
    name: "Black Belt",
    weeks: "Level 4 · By invitation",
    weekStart: null,
    weekEnd: null,
    quote: "For those who finished what they started.",
    summary:
      "Level 4 launches later this year. Learners who complete the challenge get an exclusive offer to continue.",
    waitlistUrl: "https://icelandic.ai/course/icelandic-level-4/",
    waitlistLabel: "Join the Level 4 waiting list",
    achievements: [
      "Level 4 launches later this year",
      "Exclusive offer for challenge finishers",
      "Invitation only",
      "Keep training beyond the challenge",
    ],
    levelComplete: 4,
    locked: true,
    color: "#121212",
    ring: "#000000",
    map: { x: 620, y: 430 },
  },
];
